import { cloneDeep, defaultsDeep } from 'lodash'
import { Manufacturer } from '../models/manufacturer.entity'

// Initial states

const MANUFACTURER_INITIAL_STATE: Partial<Manufacturer> = {
  name: undefined,
  externalId: undefined,
}

// Init

export function initManufacturer(
  manufacturer: Partial<Manufacturer> = {},
): Manufacturer {
  return defaultsDeep(cloneDeep(manufacturer), MANUFACTURER_INITIAL_STATE)
}
